<div class="row">
    <div [ngClass]="isEdit || isAdd ? 'col-sm-6' : 'col-sm-11'">
        <kendo-grid #tableGrid
                    [data]="gridData"
                    [pageSize]="gridState.take"
                    [skip]="gridState.skip"
                    [sort]="gridState.sort"
                    [filter]="gridState.filter"
                    [pageable]="true"
                    [sortable]="true"
                    [filterable]="true"
                    [resizable]="true"
                    (dataStateChange)="dataStateChange($event)">
            <kendo-grid-column title="Action">
                <ng-template kendoGridCellTemplate let-dataItem>
                    <button type="button" class="btn btn-sml btn-success m-1" title="Edit" tabindex="-1" (click)="edit(dataItem.carrierServiceID)"><i class="fas fa-pencil-alt"></i></button>
                    <!--<button type="button" class="btn btn-sml btn-danger m-1" title="Delete" tabindex="-1" (click)="delete(dataItem.carrierServiceID)"><i class="fas fa-times"></i></button>-->
                </ng-template>
            </kendo-grid-column>
            <kendo-grid-column field="carrierServiceID" title="ID"></kendo-grid-column>
            <kendo-grid-column field="abbreviation" title="Abbreviation"></kendo-grid-column>
            <kendo-grid-column field="description" title="Description"></kendo-grid-column>
            <kendo-grid-column field="isLoadServiceRequirement" title="Used for Load Service Req">
                <ng-template kendoGridCellTemplate let-dataItem>
                    <input type="checkbox" [checked]="dataItem.isLoadServiceRequirement" style="cursor: pointer;margin: 10px; transform: scale(1.5);" disabled />
                </ng-template>
            </kendo-grid-column>
        </kendo-grid>
    </div>
    <div class="col-sm-1" *ngIf="!isEdit && !isAdd">
        <button class="btn btn-sml btn-primary" title="Add New" tabindex="-1" (click)="addNew()" *ngIf="!isEdit && !isAdd"><i class="fas fa-plus"></i></button>
    </div>

    <div class="col-sm-6" *ngIf="isEdit || isAdd">
        <!-- Edit form -->
        <carrier-service-form [tableID]="tableID" (onRefresh)="cancelEdit()"></carrier-service-form>
    </div>
</div>
